import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["valid"]
const _hoisted_2 = {
  slot: "expandable-content",
  class: "remote-choices__inner"
}
const _hoisted_3 = {
  slot: "expandable-content",
  class: "remote-choices__inner"
}

import {computed, reactive, watch, PropType} from 'vue';
    import {AddressView, WhereConditionsBriefRequest, WorkingStatusRequest} from '@/common/api/api-raw-types';
    import {useVuelidate} from '@vuelidate/core';
    import {required} from '@vuelidate/validators';
    import LocationAutocomplete from '@/common/components/remote-choices/LocationAutocomplete.vue';
    import RatioSelect from '@/common/components/remote-choices/RatioSelect.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RemoteChoices',
  props: {
        choices: {type: Object as PropType<WhereConditionsBriefRequest>, required: true},
        frequencyLimit: Number,
        hideHybrid: Boolean,
    },
  emits: ["update:choices"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const state: WhereConditionsBriefRequest = reactive({
        workingStatus: props.choices.workingStatus || undefined,
        remoteFrequency: undefined,
        remote: props.choices.remote || undefined,
        address: props.choices.address || undefined,
    });

    const isRemotely = computed(() => state.workingStatus === WorkingStatusRequest.REMOTELY);
    const isHybrid = computed(() => state.workingStatus === WorkingStatusRequest.HYBRID);
    const isOnSite = computed(() => state.workingStatus === WorkingStatusRequest.ON_SITE);

    if (isHybrid.value && props.choices.remoteFrequency) {
        /* eslint-disable-next-line vue/no-setup-props-destructure */
        state.remoteFrequency = props.choices.remoteFrequency;
    }

    const rules = computed(() => ({
        workingStatus: {
            required,
        },
        remoteFrequency: {
            ...[isHybrid.value && required],
        },
        address: {
            ...[(isOnSite.value || isHybrid.value) && required],
        },
    }));

    const calculRemoteFrequency = computed(() => {
        if (isRemotely.value) {
            return props.frequencyLimit || 5;
        }
        if (isOnSite.value) {
            return 0;
        }
        return state.remoteFrequency;
    });

    const computedHideHybrid = computed(() => props.hideHybrid || props.frequencyLimit === 1);

    const payload = computed(
        (): WhereConditionsBriefRequest => ({
            workingStatus: state.workingStatus,
            remote: isHybrid.value || isRemotely.value,
            remoteFrequency: calculRemoteFrequency.value,
            address: isRemotely.value ? undefined : state.address,
        }),
    );

    const v$ = useVuelidate(rules, state);

    function workingStatusUpdate(event: CustomEvent) {
        const {value} = event.detail;
        state.workingStatus = value;
    }

    function addressUpdate(address: AddressView) {
        state.address = address;
        v$.value.address.$touch();
    }

    function remoteFrequencyUpdate(frequency: number) {
        state.remoteFrequency = frequency;
        v$.value.remoteFrequency.$touch();
    }

    function refreshPayload() {
        emit('update:choices', payload.value, !v$.value.$invalid);
    }

    watch(state, refreshPayload, {deep: true, immediate: true});

return (_ctx: any,_cache: any) => {
  const _component_joy_radio = _resolveComponent("joy-radio")!
  const _component_joy_wrapper = _resolveComponent("joy-wrapper")!
  const _component_joy_radio_group = _resolveComponent("joy-radio-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "remote-choices",
    valid: _unref(v$).$invalid ? 'false' : 'true'
  }, [
    _createVNode(_component_joy_radio_group, {
      name: "select-remote",
      value: _unref(v$).workingStatus.$model,
      onJoyRadioGroupValueChange: workingStatusUpdate
    }, {
      default: _withCtx(() => [
        _createVNode(_component_joy_radio, {
          required: "",
          theme: "outline",
          value: "REMOTELY"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.remote.choices.remotely')), 1)
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_joy_radio, {
          required: "",
          theme: "outline",
          value: "HYBRID",
          "data-testid": "remote-choices-hybrid-radio-selection"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.remote.choices.hybrid')) + " ", 1),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_joy_wrapper, {
                direction: "column",
                align: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(LocationAutocomplete, {
                    required: isHybrid.value,
                    address: _unref(v$).address.$model,
                    error: _unref(v$).address.$error,
                    "data-testid": "remote-choices-hybrid-location",
                    "onUpdate:address": addressUpdate
                  }, null, 8, ["required", "address", "error"]),
                  _createVNode(RatioSelect, {
                    required: isHybrid.value,
                    ratio: _unref(v$).remoteFrequency.$model,
                    error: _unref(v$).remoteFrequency.$error,
                    limit: __props.frequencyLimit,
                    "data-testid": "remote-choices-hybrid-remote-frequency",
                    "onUpdate:ratio": remoteFrequencyUpdate
                  }, null, 8, ["required", "ratio", "error", "limit"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, !computedHideHybrid.value]
        ]),
        _createVNode(_component_joy_radio, {
          required: "",
          theme: "outline",
          value: "ON_SITE"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('client.project.component.remote.choices.on.site')) + " ", 1),
            _createElementVNode("div", _hoisted_3, [
              (_unref(v$).workingStatus.$model === 'ON_SITE')
                ? (_openBlock(), _createBlock(LocationAutocomplete, {
                    key: 0,
                    required: isOnSite.value,
                    address: _unref(v$).address.$model,
                    error: _unref(v$).address.$error,
                    "data-testid": "remote-choices-on-site-location",
                    "onUpdate:address": addressUpdate
                  }, null, 8, ["required", "address", "error"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ], 8, _hoisted_1))
}
}

})